import Vue from '@/index.js'

import page from '@/mixins/page'

import sectionCategories from '@/components/sections/section-categories'
import layoutCategoryCard from '@/components/layout/category/layout-category-card'

export default new Vue({
  el: '#app',
  components: {
    sectionCategories,
    layoutCategoryCard
  },
  mixins: [page]
})
